import request from '../tools/request'
import exportFileRequest from '../tools/request'

// 获取养护监控数据
export function getMaintainData (body) {
  return request({
    url: '/api/maintain/maintainPlan/getMaintainData',
    method: 'post',
    params: body
  })
}

// 导出传感器历史信息
export function exportNodeHistoryInfo (body) {
  return request({
    url: '/api/maintain/node/exportNodeHistoryInfo',
    method: 'get',
    params: body
  })
}
// 查询虫情类型
export function selectPestType () {
  return request({
    url: '/api/maintain/pest/board/selectPestType',
    method: 'post'
  })
}
// 添加虫情类型
export function addTypeChongqing (body) {
  return request({
    url: '/api/maintain/pest/board/addType',
    method: 'post',
    params: body
  })
}

// 删除虫情类型
export function DelTypeChongqing (body) {
  return request({
    url: '/api/maintain/pest/board/deleteType',
    method: 'post',
    params: body
  })
}
// 根据传感器ID模糊查找传感器信息
export function findNodeLike (body) {
  return request({
    url: '/api/maintain/node/findNodeLike',
    method: 'post',
    params: body
  })
}

// 传感器批量入垛
export function nodesIntoStack (body) {
  return request({
    url: '/api/maintain/node/nodesIntoStack',
    method: 'post',
    data: body
  })
}
// 传感器修改确认
export function UpdataStackQue (body) {
  return request({
    url: '/api/maintain/node/nodesUpdateStack',
    method: 'post',
    data: body
  })
}
// 传感器替换
export function nodeReplace (body) {
  return request({
    url: 'api/maintain/node/nodeReplace',
    method: 'post',
    data: body
  })
}

// 传感器批量解垛
export function nodesOutStack (body) {
  return request({
    url: '/api/maintain/node/nodesOutStack',
    method: 'post',
    data: body
  })
}

// 查看传感器历史信息
export function queryNodeHistoryInfo (body) {
  return request({
    url: '/api/maintain/node/queryNodeHistoryInfo',
    method: 'post',
    params: body
  })
}

// 查看传感器历史平均信息
export function queryNodeAvgHistoryInfo (body) {
  return request({
    url: '/api/maintain/node/queryNodeAvgHistoryInfo',
    method: 'post',
    params: body
  })
}

// 查询传感器实时信息
export function queryRtNodeMonitInfo (body) {
  return request({
    url: '/api/maintain/node/queryRtNodeMonitInfo',
    method: 'post',
    params: body
  })
}

// 查询传感器监控实时信息接口
export function searchMonitorData (body) {
  return request({
    url: '/api/maintain/node/searchMonitorData',
    method: 'post',
    params: body
  })
}

// 根据传感器ID查找传感器信息
export function findNodeById (body) {
  return request({
    url: '/api/maintain/node/findNodeById',
    method: 'post',
    params: body
  })
}

// 获取传感器操作日志列表
export function nodeOperationLog (body) {
  return request({
    url: '/api/maintain/node/nodeOperationLog',
    method: 'post',
    params: body
  })
}

// 获取传感器修改数据
export function UpdataSersor (body) {
  return request({
    url: '/api/maintain/node/findNodeById',
    method: 'post',
    params: body
  })
}

// 查询虫情板列表
export function queryBoard (body) {
  return request({
    url: '/api/maintain/pest/board/query',
    method: 'post',
    params: body
  })
}

// 新增虫情板
export function addBoard (body) {
  return request({
    url: '/api/maintain/pest/board/add',
    method: 'post',
    data: body
  })
}

// 删除虫情板
export function delBoard (body) {
  return request({
    url: '/api/maintain/pest/board/del',
    method: 'delete',
    params: body
  })
}

// 根据虫情板主键ID集合批量删除虫情板，以,隔开
export function bathDelBoard (body) {
  return request({
    url: '/api/maintain/pest/board/bathDel',
    method: 'delete',
    params: body
  })
}

// 查询虫情板详情列表
export function queryBoardDetail (body) {
  return request({
    url: '/api/maintain/pest/board/detail/query',
    method: 'post',
    params: body
  })
}

// 查看杀虫申请信息
export function applyInfo (body) {
  return request({
    url: '/api/maintain/pest/pest/kill/applyInfo',
    method: 'post',
    params: body
  })
}

// 杀虫申请
export function handleApply (body) {
  return request({
    url: '/api/maintain/pest/pest/kill/apply',
    method: 'post',
    data: body
  })
}

// 杀虫审核
export function handleCheck (body) {
  return request({
    url: '/api/maintain/pest/pest/kill/check',
    method: 'post',
    data: body
  })
}

// 虫情板变更
export function pestChange (body) {
  return request({
    url: '/api/maintain/pest/board/pestChange',
    method: 'post',
    params: body
  })
}

// 虫情板变更历史
export function queryHistory (body) {
  return request({
    url: '/api/maintain/pest/board/queryHistory',
    method: 'post',
    params: body
  })
}

// 获取阶段预警值
export function queryPhases (body) {
  return request({
    url: '/api/maintain/pest/setting/queryPhases',
    method: 'post',
    params: body
  })
}

// 监控规则设置
export function setPhases (body) {
  return request({
    url: '/api/maintain/pest/setting/set',
    method: 'post',
    data: body
  })
}

// 巡查人员设置
export function addPerson (body) {
  return request({
    url: '/api/maintain/pest/setting/person/add',
    method: 'post',
    data: body
  })
}

// 删除巡查人员
export function delPerson (body) {
  return request({
    url: '/api/maintain/pest/setting/person/del',
    method: 'delete',
    params: body
  })
}

// 根据巡查人员规则ID集合删除巡查人员，以,隔开
export function bathDelPerson (body) {
  return request({
    url: '/api/maintain/pest/setting/person/bathDel',
    method: 'delete',
    params: body
  })
}

// 质检数据批量导入
export function batchImport (body) {
  return request({
    url: '/api/maintain/qualityTesting/batchImport',
    method: 'post',
    data: body
  })
}

// 查询质检数据
export function qualityTesting (body) {
  return request({
    url: '/api/maintain/qualityTesting/list',
    method: 'post',
    params: body
  })
}

// 删除质检数据
export function delQualityTesting (body) {
  return request({
    url: '/api/maintain/qualityTesting/del',
    method: 'delete',
    params: body
  })
}

// 根据质检数据ID集合批量删除质检数据，以,隔开
export function bathDelQualityTesting (body) {
  return request({
    url: '/api/maintain/qualityTesting/bathDel',
    method: 'delete',
    params: body
  })
}

// 新增质检数据
export function addQualityTesting (body) {
  return request({
    url: '/api/maintain/qualityTesting/add',
    method: 'post',
    data: body
  })
}

// 修改质检数据
export function updateQualityTesting (body) {
  return request({
    url: '/api/maintain/qualityTesting/update',
    method: 'post',
    data: body
  })
}

// 根据主键ID查询质检数据详情
export function detailQualityTesting (body) {
  return request({
    url: '/api/maintain/qualityTesting/detail',
    method: 'post',
    params: body
  })
}

// 根据主键ID查询质检报告
export function reportQualityTesting (body) {
  return request({
    url: '/api/maintain/qualityTesting/report',
    method: 'post',
    params: body
  })
}

// 修改质检报告
export function updateReportQualityTesting (body) {
  return request({
    url: '/api/maintain/qualityTesting/updateReport',
    method: 'post',
    data: body
  })
}

// 新增预警值设置
export function setAlarm (body) {
  return request({
    url: '/api/maintain/alarm/set',
    method: 'post',
    data: body
  })
}

// 获取预警阶段
export function queryAlarm (body) {
  return request({
    url: '/api/maintain/alarm/queryByPhases',
    method: 'get',
    params: body
  })
}

// 查询预警信息
export function queryEarlyWarning (body) {
  return request({
    url: '/api/maintain/alarm/queryEarlyWarning',
    method: 'post',
    params: body
  })
}

// 预警统计
export function earlyStatistics (body) {
  return request({
    url: '/api/maintain/alarm/earlyStatistics',
    method: 'post',
    params: body
  })
}

// 新建养护单
export function addMaintainPlan (body) {
  return request({
    url: '/api/maintain/maintainPlan/add',
    method: 'post',
    data: body
  })
}

// 修改养护单
export function updateMaintainPlan (body) {
  return request({
    url: '/api/maintain/maintainPlan/update',
    method: 'post',
    data: body
  })
}

// 查询养护计划列表
export function queryMaintainPlan (body) {
  return request({
    url: '/api/maintain/maintainPlan/queryMaintainPlan',
    method: 'post',
    params: body
  })
}

// 审核养护计划
export function checkMaintainPlan (body) {
  return request({
    url: '/api/maintain/maintainPlan/check',
    method: 'post',
    data: body
  })
}

// 查看养护计划详情
export function detailMaintainPlan (body) {
  return request({
    url: '/api/maintain/maintainPlan/detail',
    method: 'get',
    params: body
  })
}

// 删除养护计划
export function delMaintainPlan (body) {
  return request({
    url: '/api/maintain/maintainPlan/del',
    method: 'delete',
    params: body
  })
}

// 根据养护计划ID集合批量删除养护计划，以,隔开
export function bathDelMaintainPlan (body) {
  return request({
    url: '/api/maintain/maintainPlan/bathDel',
    method: 'delete',
    params: body
  })
}

// 导出养护计划列表
export function exportMaintainPlan (body) {
  return request({
    url: '/api/maintain/maintainPlan/exportMaintainPlan',
    method: 'post',
    data: body
  })
}

// 养护到期汇总列表
export function queryDueMaintainPlan (body) {
  return request({
    url: '/api/maintain/maintainPlan/queryDueMaintainPlan',
    method: 'post',
    params: body
  })
}

// 导出养护计划汇总列表
export function exportMaintainPlanHistory (body) {
  return request({
    url: '/api/maintain/maintainPlan/exportMaintainPlanHistory',
    method: 'post',
    data: body
  })
}

// 养护计划历史记录汇总列表
export function queryMaintainPlanAndHistorys (body) {
  return request({
    url: '/api/maintain/maintainPlan/queryMaintainPlanAndHistorys',
    method: 'post',
    params: body
  })
}

// 养护计划历史记录列表
export function queryMaintainPlanAndHistorysById (body) {
  return request({
    url: '/api/maintain/maintainPlan/queryMaintainPlanAndHistorysById',
    method: 'post',
    params: body
  })
}

// 养护阶段变更
export function changeStage (body) {
  return request({
    url: '/api/maintain/maintainPlan/changeStage',
    method: 'post',
    data: body
  })
}

// 开垛使用
export function stackOpenUse (body) {
  return request({
    url: '/api/maintain/maintainPlan/stackOpenUse',
    method: 'post',
    params: body
  })
}

// 查询任务信息列表
export function queryTaskList (body) {
  return request({
    url: '/api/maintain/task/queryTaskList',
    method: 'post',
    data: body
  })
}

// 删除任务
export function delTask (body) {
  return request({
    url: '/api/maintain/task/del',
    method: 'delete',
    data: body
  })
}

// 批量删除任务
export function bathDelTask (body) {
  return request({
    url: '/api/maintain/task/bathDel',
    method: 'delete',
    data: body
  })
}

// 更改任务状态为已处理
export function dealTask (body) {
  return request({
    url: '/api/maintain/task/dealTask',
    method: 'post',
    data: body
  })
}

// 新增任务
export function addTask (body) {
  return request({
    url: '/api/maintain/task/add',
    method: 'post',
    data: body
  })
}

// 新增损耗数据
export function addLoss (body) {
  return request({
    url: '/api/maintain/loss/add',
    method: 'post',
    data: body
  })
}

// 按类型分页查询损耗数据
export function queryPageList (body) {
  return request({
    url: '/api/maintain/loss/queryPageList',
    method: 'post',
    data: body
  })
}

// 根据损耗主键ID集合批量删除
export function bathDelPageList (body) {
  return request({
    url: '/api/maintain/loss/bathDel',
    method: 'delete',
    data: body
  })
}

// 删除损耗
export function delPageList (body) {
  return request({
    url: '/api/maintain/loss/del',
    method: 'delete',
    data: body
  })
}

// 损耗统计首页统计
export function indexLossStatistical (body) {
  return request({
    url: '/api/maintain/loss/indexLossStatistical',
    method: 'post',
    data: body
  })
}

// 获取传感器历史数据列表
export function getNodeHistory (body) {
  return request({
    url: '/api/maintain/node/getNodeHistory',
    method: 'post',
    params: body
  })
}

// 根据垛位查询当前养护计划
export function queryMaintainPlanBySite (body) {
  return request({
    url: '/api/maintain/maintainPlan/queryMaintainPlanBySite',
    method: 'post',
    params: body
  })
}

// 查询全部质检数据接口 (质检数据批量导出
export function allList (body) {
  return request({
    url: '/api/maintain/qualityTesting/allList',
    method: 'post',
    params: body
  })
}

// 首页-查询垛位列表
export function searchStackList (body) {
  return request({
    url: '/api/homepage/data/searchStackList',
    method: 'post',
    data: body
  })
}

// 首页-垛位信息
export function searchStackInfo (body) {
  return request({
    url: '/api/homepage/data/searchStackInfo',
    method: 'post',
    params: body
  })
}

// 首页-户外温湿度
export function searchAirMoirAndTemp (body) {
  return request({
    url: '/api/homepage/data/searchAirMoirAndTemp',
    method: 'post',
    params: body
  })
}

// 预警管理-查询短信推送状态
export function searchEventFlag (body) {
  return request({
    url: '/api/maintain/alarm/searchEventFlag',
    method: 'post',
    params: body
  })
}

// 预警管理-修改短信推送
export function updateEventFlag (body) {
  return request({
    url: '/api/maintain/alarm/updateEventFlag',
    method: 'post',
    params: body
  })
}

// 首页-查询楼栋预警位置集合
export function searchWarningSiteList (body) {
  return request({
    url: '/api/homepage/data/searchWarningSiteList',
    method: 'post',
    params: body
  })
}

// 首页-预警ID集合
export function searchWarningIdList (body) {
  return request({
    url: '/api/homepage/data/searchWarningIdList',
    method: 'post',
    params: body
  })
}

// 获取养护品吸数据
export function getPinXiData (body) {
  return request({
    url: '/api/maintain/maintainPlan/productAbsorptionList',
    method: 'post',
    params: body
  })
}

// 养护评吸计划历史记录列表
export function querypinxiPlanAndHistorysById (body) {
  return request({
    url: '/api/maintain/maintainPlan/productAbsorption',
    method: 'get',
    params: body
  })
}

// 修改养护评吸详情
export function updatepinxiPlan (body) {
  return request({
    url: '/api/maintain/maintainPlan/productAbsorptionUpdate',
    method: 'post',
    data: body
  })
}

// 查看设备详情
export function querySheBeiDetail (body) {
  return request({
    url: 'api/history/report/searchDetailsDataReport',
    method: 'post',
    params: body
  })
}

// 查看设备平均详情
export function querySheBeiDetailAVG (body) {
  return request({
    url: 'api/history/report/searchHistoryDetailReport',
    method: 'post',
    params: body
  })
}
// 数据对比
export function DataDBiDong (body) {
  return request({
    url: 'api/history/report/searchDetaCompareReport',
    method: 'post',
    params: body
  })
}
// 文件下载
export function DataDaoExcel (body) {
  return request({
    url: 'api/report/exportBusinessReport',
    method: 'post',
    params: body
  })
}


// 获取养护计划
export function GetMaintainPlanDetailYu (body) {
  return request({
    url: 'api/maintain/maintainPlan/findMaintainPlan',
    method: 'post',
    params: body
  })
}

// 获取myChart数据
export function GetmyChartDetailYu (body) {
  return request({
    url: 'api/maintain/alarm/findEarlyWaringHistoryData',
    method: 'post',
    params: body
  })
}


// 发送预警处理信息
export function sengYujingMessage (body) {
  return request({
    url: 'api/maintain/alarm/disposeEarlyWaringMessage',
    method: 'post',
    params: body
  })
}
// // 导出Excel文件
// export const exportExcel = (params) => {
//   return exportFileRequest("/api/report/exportBusinessReport",params)
// }




// WEBPACK FOOTER //
// ./src/api/maintain.js